import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

import useLocationForm from './useLocationForm'
import { ModalActions } from '../../styled-components'

const CODE_MAX_LENGTH = 4
const NAME_MAX_LENGTH = 255

const LocationForm = () => {
  const {
    codeLabel,
    nameLabel,
    codeHint,
    codeChangeWarning,
    submitLabel,
    cancelLabel,
    code,
    name,
    codeError,
    nameError,
    formError,
    hasCodeError,
    hasNameError,
    isFormErrorHidden,
    isCodeWarningHidden,
    isSubmitDisabled,
    isSaving,
    onCodeChange,
    onNameChange,
    close,
    submit,
  } = useLocationForm()

  return (
    <form onSubmit={submit}>
      <SDFormControl caption={codeHint} error={codeError}>
        {/* @ts-expect-error SDInput is a JS component */}
        <SDInput
          id='fiscal-code-location-code'
          label={codeLabel}
          currentValue={code}
          maxLength={CODE_MAX_LENGTH}
          error={hasCodeError}
          outerOnchange={onCodeChange}
        />
      </SDFormControl>
      <SDNotification type='warning' hidden={isCodeWarningHidden} primaryText={codeChangeWarning} />
      <SDFormControl error={nameError}>
        {/* @ts-expect-error SDInput is a JS component */}
        <SDInput
          id='fiscal-code-location-name'
          label={nameLabel}
          currentValue={name}
          maxLength={NAME_MAX_LENGTH}
          error={hasNameError}
          outerOnchange={onNameChange}
        />
      </SDFormControl>
      <SDNotification type='negative' hidden={isFormErrorHidden} primaryText={formError} />
      <ModalActions>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton id='fiscal-code-location-cancel-btn' type='button' block={false} disabled={isSaving} onClick={close}>
          {cancelLabel}
        </SDButton>
        {/* @ts-expect-error SDButton is a JS component */}
        <SDButton
          id='fiscal-code-location-submit-btn'
          type='submit'
          block={false}
          disabled={isSubmitDisabled}
          isLoading={isSaving}
        >
          {submitLabel}
        </SDButton>
      </ModalActions>
    </form>
  )
}

export default LocationForm
